import $service from '@/libs/request'
import store from '@/store'
import authConfig from './authConfig'

export default class authService {
  axiosIns = $service

  isAuth = () => {
    if(localStorage.getItem(authConfig.userToken) && localStorage.getItem(authConfig.userData)) {
      return true
    } else {
      return false
    }
  }

  register = (...args) => {
    return this.axiosIns.post(authConfig.api.register, ...args)
  }

  login = (...args) => {
    return new Promise((resolve, refuse) => {

      this.axiosIns.post(authConfig.api.login, ...args)
        .then(res => {
          if(res && res.code == 0)
            store.commit('user/account', res.data)
          resolve(res)
        }).catch(err => {
          refuse(err)
        })
    })
  }
  
  modify = (...args) => {
    return this.axiosIns.put(authConfig.api.modifyUser, ...args)
  }

  chiaModify = (...args) => {
    return this.axiosIns.put(authConfig.api.modifyWalletChia, ...args)
  }

  userDetail = () => {
    return new Promise((resolve, refuse) => {
      this.axiosIns.get(authConfig.api.userDetail)
        .then(res => {
          if(res && res.code == 0)
            store.commit('user/account', {user: res.data.user})
          resolve(res)
        }).catch(err => {
          refuse(err)
        })
    })
  }
}